import { store } from "@stofloos/stores/store";

export const hasRole = (role) => {
    return  store.getState().StofwareAuth.user.user_claims.roles.includes(role);
};